// Make $ global
window.$ = window.jQuery;
